webpackJsonp([3,17],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(239),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(426),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d3bbca8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgN0MwLjQ0NzcxNSA3IDAgNy40NDc3MiAwIDhDMCA4LjU1MjI4IDAuNDQ3NzE1IDkgMSA5VjdaTTE2LjcwNzEgOC43MDcxMUMxNy4wOTc2IDguMzE2NTggMTcuMDk3NiA3LjY4MzQyIDE2LjcwNzEgNy4yOTI4OUwxMC4zNDMxIDAuOTI4OTMyQzkuOTUyNjIgMC41Mzg0MDggOS4zMTk0NiAwLjUzODQwOCA4LjkyODkzIDAuOTI4OTMyQzguNTM4NDEgMS4zMTk0NiA4LjUzODQxIDEuOTUyNjIgOC45Mjg5MyAyLjM0MzE1TDE0LjU4NTggOEw4LjkyODkzIDEzLjY1NjlDOC41Mzg0MSAxNC4wNDc0IDguNTM4NDEgMTQuNjgwNSA4LjkyODkzIDE1LjA3MTFDOS4zMTk0NiAxNS40NjE2IDkuOTUyNjIgMTUuNDYxNiAxMC4zNDMxIDE1LjA3MTFMMTYuNzA3MSA4LjcwNzExWk0xIDlIMTZWN0gxVjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a2ff84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var settings;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.localStorage.engsettings) {
              _context.next = 6;
              break;
            }

            settings = JSON.parse(window.localStorage.engsettings);

            console.log("GOT SETTINGS FROM LOCALSTORAGE");

            return _context.abrupt("return", settings);

          case 6:
            console.log("WAS MADE");
            window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));

          case 8:
            return _context.abrupt("return", [true, true]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newsetting) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.localStorage.engsettings) {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newsetting));
            } else {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var settingsService = {
  getSettings: getSettings,
  setSettings: setSettings
};

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrowIconPath; });
var getArrowIconPath = function getArrowIconPath(languageDirection) {

    var arrowIconNext = void 0;
    var arrowIconPrevious = void 0;

    if (languageDirection === 'rtl') {
        arrowIconNext = __webpack_require__(205).default;
        arrowIconPrevious = __webpack_require__(206).default;
    } else {
        arrowIconNext = __webpack_require__(206).default;
        arrowIconPrevious = __webpack_require__(205).default;
    }

    return {
        arrowIconNext: arrowIconNext,
        arrowIconPrevious: arrowIconPrevious
    };
};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5MS42NCA1OC4yIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6bm9uZTtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpzcXVhcmU7c3Ryb2tlLWxpbmVqb2luOmJldmVsO3N0cm9rZS13aWR0aDoxMXB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjUuNSIgeTE9IjI4Ljk4IiB4Mj0iNzcuODMiIHkyPSIyOC45OCIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjYyLjY1IiB5MT0iNTAuNDIiIHgyPSI4My44NyIgeTI9IjI5LjIiLz48bGluZSBjbGFzcz0iY2xzLTEiIHgxPSI2Mi4xOSIgeTE9IjcuNzgiIHgyPSI4My40MSIgeTI9IjI5Ii8+PC9nPjwvZz48L3N2Zz4=");

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("341b2bf2", content, true, {});

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "#progressBar{position:relative;top:-7px}.slider::-moz-range-thumb{width:20px;height:20px;border-radius:50%;background:#555fff;cursor:pointer}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:20px;height:20px;background:#555fff;border-radius:50%;cursor:pointer}.disabledBtn{display:none}.audio-player-container{display:flex;align-items:center;justify-content:center;gap:8px}.speed-btn{background:var(--bg-primary, #555fff);color:#fff;border:none;border-radius:16px;padding:4px 8px;font-size:12px;font-weight:500;min-width:36px;height:24px;cursor:pointer;transition:all .2s ease;user-select:none}.speed-btn:hover{background:var(--bg-primary-hover, #4444ee);transform:scale(1.05)}.speed-btn:active{transform:scale(0.95)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/AudioPlayer.scss"],"names":[],"mappings":"AAAA,aACE,kBAEA,QAAA,CAGF,0BACE,WACA,YACA,kBAEA,mBACA,cAAA,CAGF,8BACE,wBACA,gBACA,WACA,YACA,mBACA,kBACA,cAAA,CA4DF,aACE,YAAA,CAGF,wBACE,aACA,mBACA,uBACA,OAAA,CAGF,WACE,sCACA,WACA,YACA,mBACA,gBACA,eACA,gBACA,eACA,YACA,eACA,wBACA,gBAAA,CAEA,iBACE,4CACA,qBAAA,CAGF,kBACE,qBAAA,CAAA","file":"AudioPlayer.scss","sourcesContent":["#progressBar {\n  position: relative;\n  // top: -9px;\n  top: -7px;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n\n  background: #555fff;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #555fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n// input[type=\"range\"] {\n//   -webkit-appearance: none;\n//   // margin-right: 15px;\n//   width: 120px;\n//   height: 7px;\n//   background: #aaabbb;\n//   border-radius: 5px;\n//   background-position: right center;\n//   background-image: linear-gradient(#7070af, #111199);\n//   background-size: 0% 100%;\n//   background-repeat: no-repeat;\n// }\n\n// input[type=\"range\"]::-webkit-slider-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #555;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-moz-range-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #390b8d;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// input[type=\"range\"]::-moz-range-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE\n// .slider::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: blue;\n// }\n\n.disabledBtn {\n  display: none;\n}\n\n.audio-player-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.speed-btn {\n  background: var(--bg-primary, #555fff);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  \n  &:hover {\n    background: var(--bg-primary-hover, #4444ee);\n    transform: scale(1.05);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2144f390", content, true, {});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created: function created() {
    this.getAudio();
  },

  watch: {
    urlId: function urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx: function idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay: function autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this = this;

      console.log(this.autoplay);
      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _ref2, sound_file;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context.sent;
                    sound_file = _ref2.sound_file;

                    _this.audioSrc = sound_file;
                    if (_this.autoplay && _this.audioSrc) {
                      // this.isStop = false;
                      _this.playAudio();
                    }

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioSrc = null;
      }
    },
    playAudio: function playAudio(ev) {
      var _this2 = this;

      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(function () {}, 1500);
      }
      var audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing");
      this.$store.commit("setIsPlaying", true);
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(function (e) {
        console.log(e);
        _this2.$store.commit("setError", e);
        _this2.$store.commit("setIsPlaying", false);
      });
      document.getElementById('speaker-svg').classList.remove("is-playing");
    }
  },
  updated: function updated() {
    console.log("audio is updated");
  },
  destroyed: function destroyed() {
    this.isStop = true;
  },

  components: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5ddadbf4", content, true, {});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".audio-btn{cursor:pointer;position:relative}.audio .audio-btn{width:28px !important;aspect-ratio:1/1}.audio .audio-btn svg{width:100%;height:100%}.speaker-svg{width:60px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.is-playing{box-shadow:0 0 10px 6px var(--bubble-bg-selected);border-radius:50%}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/audioBtn.scss","/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,eACA,iBAAA,CAGF,kBACE,sBACA,gBAAA,CAGF,sBACE,WACA,WAAA,CAGF,aACE,WClBA,kBACA,QACA,SACA,+BAAA,CDmBF,YACE,kDACA,iBAAA,CAAA","file":"audioBtn.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.audio-btn {\n  cursor: pointer;\n  position: relative;\n}\n\n.audio .audio-btn {\n  width: 28px !important;\n  aspect-ratio: 1/1;\n}\n\n.audio .audio-btn svg {\n  width: 100%;\n  height: 100%;\n}\n\n.speaker-svg {\n  width: 60px;\n  @include absCenter;\n\n}\n.is-playing {\n  box-shadow: 0 0 10px 6px var(--bubble-bg-selected);\n  border-radius: 50%;\n}","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": __webpack_require__(208).default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    height: { type: String, required: true }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: (_vm.height + "px")
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settingsService__ = __webpack_require__(209);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AudioPlayer",
  data: function data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },

  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_settingsService__["a" /* settingsService */].getSettings();

            case 2:
              _this.soundSetting = _context.sent;

              _this.loadSavedSpeed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.audio.pause();
  },

  watch: {
    urlId: function urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile: function audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio: function audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar: function progressBar() {
      this.$refs.progressBar.style.backgroundSize = (this.progressBar - 0) * 100 / (100 - 0) + "% 100%";
    },
    $route: function $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this2 = this;

      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
            var _ref2, mediaUrl;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context2.sent;
                    mediaUrl = _ref2.mediaUrl;

                    _this2.audioFile = mediaUrl;

                    //this.makeAudio(this.audioFile);
                    // if (this.autoplay) {
                    //   this.isStop = false;
                    //   this.playAudio();
                    // }

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioFile = null;
      }
    },
    changeProgress: function changeProgress(e) {
      if (this.audio) this.audio.currentTime = this.audio.duration / 100 * e.target.value;
      var el = e.target;
      console.log((el.value - 0) * 100 / (100 - 0) + "% 100%");
      el.style.backgroundSize = (el.value - 0) * 100 / (100 - 0) + "% 100%";
    },
    play: function play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause: function pause() {
      this.audio.pause();
    },
    makeAudio: function makeAudio(audioFile) {
      var _this3 = this;

      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", function (e) {
        _this3.progressBar = _this3.audio.currentTime / _this3.audio.duration * 100;
      });

      this.audio.addEventListener("ended", function () {
        _this3.audio.currentTime = 0;
        _this3.audio.pause();
      });
    },
    cycleSpeed: function cycleSpeed() {
      var currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      var nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];

      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }

      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed: function loadSavedSpeed() {
      var savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio-player-container"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        __webpack_require__(208).default :
        __webpack_require__(240).default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.playbackRate) + "x\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0iIzU1NTVGRiIvPgo8cmVjdCB4PSIxMC4zMjkxIiB3aWR0aD0iNS43NzE4MSIgaGVpZ2h0PSIyNSIgcng9IjIuODg1OTEiIGZpbGw9IiM1NTU1RkYiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(243)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(244);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("0c4970e0", content, true, {});

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"progressBar.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressBar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__progressBar_scss__);

//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "progress-bar",
  props: {
    max: {
      type: Number,
      default: 100
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      style: {}
    };
  },
  created: function created() {
    this.style = { width: this.progress / this.max * 100 + "%" };
  },

  computed: {},
  watch: {
    progress: function progress() {
      this.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.style, {
        width: this.progress / this.max * 100 + "%"
      });
    }
  },
  methods: {}
});

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("351700dc", content, true, {});

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".progress-bar{border:#000 1px solid;font-size:40px;height:40px}.progress-bar .container{background-color:#41d988;text-align:center;height:100%;align-items:center}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/progressBar.scss"],"names":[],"mappings":"AACA,cACE,sBACA,eACA,WAAA,CACA,yBACE,yBACA,kBACA,YACA,kBAAA,CAAA","file":"progressBar.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n.progress-bar {\n  border: black 1px solid;\n  font-size: 40px;\n  height: 40px;\n  .container {\n    background-color: $green;\n    text-align: center;\n    height: 100%;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "container flex",
    style: (_vm.style)
  }, [_c('span', {
    staticClass: "mr-20"
  }, [_vm._v(" " + _vm._s(Math.round((_vm.progress / _vm.max) * 100)) + "%")])])])
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19b20649",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOSS1.5b5a277.mp3";

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("86881e7a", content, true, {});

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/OnBoardingModal.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,cAAc;CACf;AACD;EACE,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;CAC1B","file":"OnBoardingModal.vue","sourcesContent":["\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_courseService__ = __webpack_require__(77);



var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      closed: false,
      isAudio: 1,
      lessonImage: null
    };
  },

  props: {
    text: {
      type: String,
      default: ""
    },
    audioSrc: {
      type: String,
      default: ""
    },
    vidSrc: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "lesson"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    audioSrc: function audioSrc() {
      if (this.audioSrc) this.isAudio = 0;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var lesson;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.lessonImage = _this.imgSrc;
              lesson = void 0;

              if (!(_this.type === "lesson")) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getLessonFromServer(_this.id);

            case 5:
              lesson = _context.sent;

              if (lesson.game) _this.lessonImage = lesson.game.intro_image;

            case 7:
              if (!(_this.type === "game")) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getGame(_this.id);

            case 10:
              lesson = _context.sent;

              console.log(lesson);
              _this.lessonImage = lesson.intro_image;

            case 13:
              if (_this.audioSrc) _this.isAudio = 0;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    closePop: function closePop(e) {
      this.closed = true;
      this.$emit("clicked", this.id);
    },

    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    }
  },

  components: { AudioPlayer: __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default.a, VideoPlayer: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, AudioBtn1: __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default.a, VideoPlayer1: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, Spacer: __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default.a }
});

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("4754144f", content, true, {});

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".blackBG{background-color:var(--color-primary);opacity:.4;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10}.modal{display:flex;flex-direction:column;align-items:center;text-align:center;z-index:1001;background-color:var(--bg-primary);opacity:1;padding:32px 18px !important;border-radius:4px;max-width:calc(100vw - 36px);top:80px;left:50%;margin-top:16px;transform:translate(-50%, 0);justify-content:space-between;gap:24px;max-height:75vh;overflow-y:auto}#img{width:100%;height:auto}.hide{display:none}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/src/components/onBoardingModal/style.scss"],"names":[],"mappings":"AAAA,SACE,sCACA,WACA,eACA,MACA,OACA,WACA,YACA,UAAA,CAGF,OACE,aACA,sBACA,mBACA,kBACA,aACA,mCACA,UACA,6BACA,kBACA,6BACA,SACA,SACA,gBACA,6BACA,8BACA,SACA,gBACA,eAAA,CAGF,KACE,WACA,WAAA,CAGF,MACE,YAAA,CAAA","file":"style.scss","sourcesContent":[".blackBG {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  z-index: 1001;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 32px 18px !important;\n  border-radius: 4px;\n  max-width: calc(100vw - 36px);\n  top: 80px;\n  left: 50%;\n  margin-top: 16px;\n  transform: translate(-50%, 0);\n  justify-content: space-between;\n  gap: 24px;\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n#img {\n  width: 100%;\n  height: auto;\n}\n\n.hide {\n  display: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', [_c('div', {
    staticClass: "blackBG"
  }), _vm._v(" "), _c('div', {
    staticClass: "onboarding"
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    staticClass: "video-p",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.lessonImage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "approve",
    on: {
      "click": _vm.closePop
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("OnBoardingModal.OnBoardingModal.start")) + "\n      ")])], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LOSS2.34d9197.mp3";

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY-FULL.3c0441a.mp3";

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./VICTORY-FULL.mp3": 292,
	"./VICTORY1.mp3": 301,
	"./VICTORY2.mp3": 302,
	"./VICTORY3.mp3": 303,
	"./VICTORY4.mp3": 304,
	"./VICTORY5.mp3": 305,
	"./VICTORY6.mp3": 306,
	"./VICTORY7.mp3": 307,
	"./VICTORY8.mp3": 308
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 293;

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY1.c764be9.mp3";

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY2.d309bef.mp3";

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY3.353f6b2.mp3";

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY4.718dc3e.mp3";

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY5.ef5b443.mp3";

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY6.679e925.mp3";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY7.651c4a6.mp3";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VICTORY8.32860f5.mp3";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(408);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("656bff32", content, true, {});

/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\nbutton[data-v-0d3bbca8] {\n  border: none;\n}\n.question[data-v-0d3bbca8] {\n  margin: 10px;\n}\n\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/game-page.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd","file":"game-page.vue","sourcesContent":["\nbutton[data-v-0d3bbca8] {\n  border: none;\n}\n.question[data-v-0d3bbca8] {\n  margin: 10px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__game_page_scss__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__game_page_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__game_page_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__game_summary_vue__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__game_summary_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__game_summary_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__game_header_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__game_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__game_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_progressBar_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_progressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Shared_progressBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__onBoardingModal_OnBoardingModal_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__onBoardingModal_OnBoardingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__onBoardingModal_OnBoardingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_wordService__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_settingsService__ = __webpack_require__(209);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import confetti from "canvas-confetti";



var initializeState = {
  currItems: [],
  chapter: null,
  questions: [],
  question: null,
  WIN: 0,
  LOST: 0,
  idx: 0,
  showNext: false,
  isClicked: false,
  status: "",
  submitting: false,
  choosenId: "",
  isSummary: false,
  showResults: false,
  results: [],
  onlyArbT: false,
  msg: "",
  savedWords: [],
  courseData: null,
  currentWord: null,
  mistakes: [],
  updateUser: null,
  soundSetting: [],
  isStop: false,
  autoPlay: true,
  externalData: null
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "grammar-game",
  props: ["data"],
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, initializeState);
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["words", "chapters", "user", "grammarLaws"]), {
    currentGame: function currentGame() {
      return this.$store.getters.currentGame;
    }
  }),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(_this.currentGame);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_13__services_settingsService__["a" /* settingsService */].getSettings();

            case 3:
              _this.soundSetting = _context.sent;

              _this.externalData = _this.$route.query;
              console.log(_this.externalData);
              _this.init();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    $route: function $route(to, from) {
      this.init();
    },
    currentGame: function currentGame() {
      this.courseData = this.currentGame;
    },
    question: function question() {
      this.currentWord = this.question;
    },
    grammarLaws: function grammarLaws() {
      this.init();
    },
    updateUser: function updateUser() {
      this.$store.commit("setUser", this.updateUser);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.isStop = this.soundSetting[0];
        this.autoPlay = this.soundSetting[1];
      }
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _$route$params, id, gameid;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.currItems = [], _this2.chapter = null, _this2.questions = [], _this2.idx = 0, _this2.showNext = false, _this2.isClicked = false, _this2.status = "", _this2.choosenId = "", _this2.isSummary = false, _this2.showResults = false, _this2.results = [], _this2.WIN = 0, _this2.LOST = 0, _this2.mistakes = [];
                _this2.savedWords = [];
                _$route$params = _this2.$route.params, id = _$route$params.id, gameid = _$route$params.gameid;


                if (_this2.data) {
                  _this2.currItems = _this2.grammarLaws.filter(function (w) {
                    return w.grammar === _this2.data.game.algolia_game_id;
                  });
                  console.log("curr", _this2.currItems);
                } else if (gameid) {
                  _this2.currItems = _this2.grammarLaws.filter(function (w) {
                    return w.grammar === gameid;
                  });
                  console.log("curr", _this2.currItems);
                }

                _this2.chapter = {
                  title: "משחק",
                  questionsNumber: 10
                };

                _this2.generateQuestion();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    playAudio: function playAudio(ev) {
      if (!this.isStop) return;
      // if (ev) {
      //   ev.stopPropagation();
      // }
      if (ev > 0 && ev < 9) {
        var audio = new Audio(__webpack_require__(293)("./VICTORY" + ev + ".mp3"));
        audio.play();
      } else if (ev === 0) {
        var _audio = void 0;
        _audio = new Audio(__webpack_require__(253));
        if (this.LOST % 2 === 0) _audio = new Audio(__webpack_require__(266));
        _audio.play();
      } else if (ev === 10) {
        var _audio2 = new Audio(__webpack_require__(292));
        _audio2.play();
      }
    },
    generateQuestion: function generateQuestion() {
      var lastWord = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var _$route$params2 = this.$route.params,
          type = _$route$params2.type,
          grammar = _$route$params2.grammar,
          id = _$route$params2.id;

      var questions = [];
      var items = this.currItems;
      //this.currItems[0].know = 5;
      items = items.filter(function (item) {
        return item.objectID !== lastWord.objectID;
      });
      console.log(items);
      var question = {
        qWord: this.getRandomWord(items, true),
        answers: [],
        // onlyAudio: Math.random() > 0.5 ? true : false
        onlyAudio: false
      };
      var answers = this.generateAnswer(question.qWord.exercise, "exercise", question.qWord);
      //remove the used word from items array
      answers = this.randomList(answers);
      question.answers = answers;
      questions.push(question);

      console.log(questions);
      this.questions = questions;
      this.playedItems = questions.map(function (q) {
        return q.qWord;
      });
      this.question = question;
    },


    /*
    remove word from items array
     */
    removeWord: function removeWord(word, items) {
      var newItems = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i] != word) {
          newItems.push(items[i]);
        }
      }
      return newItems;
    },
    getRandomWord: function getRandomWord() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currItems;
      var isQuestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;

      var randomNumber = Math.floor(Math.random() * items.length);
      var ranWord = items[randomNumber];
      console.log(items, randomNumber, ranWord);
      if (ranWord) {
        if (ranWord.know >= 5 && isQuestion && limit > 0) {
          return this.getRandomWord(items, isQuestion, limit - 1);
        } else {
          return ranWord;
        }
      }
    },
    generateAnswer: function generateAnswer(family, kind, rightAnswer) {
      var filteredWords = this.currItems.filter(function (i) {
        return i.objectID !== rightAnswer.objectID;
      });
      console.log("aaaa", filteredWords);
      filteredWords = filteredWords.filter(function (i) {
        return i[kind] === family;
      });
      console.log("Filtered", filteredWords);
      var answers = [rightAnswer];
      var limit = 30;
      var max = filteredWords.length <= 3 ? filteredWords.length : 3;
      for (var i = 0; i < max; i++) {
        var randomAnswer = this.getRandomWord(filteredWords, false, limit);
        var ids = answers.map(function (a) {
          return a.objectID;
        });
        ids.includes(randomAnswer.objectID) && max < limit ? max++ : answers.push(randomAnswer);
      }
      console.log(answers);
      return answers;
    },
    checkAnswerA: function checkAnswerA(answer) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _$route$params3, id, type, grammar;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _$route$params3 = _this3.$route.params, id = _$route$params3.id, type = _$route$params3.type, grammar = _$route$params3.grammar;

                if (!_this3.isClicked) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _this3.isClicked = true;
                _this3.choosenId = answer.objectID;
                if (answer.heb === _this3.question.qWord.heb) {
                  _this3.status = "right";
                  _this3.WIN = _this3.WIN + 1;
                  _this3.LOST = 0;
                  _this3.playAudio(_this3.WIN);
                  //this.playedItems[this.idx].isRight = true;
                  // const newidx = this.currItems.findIndex(
                  //   element => element.objectID === answer.objectID
                  // );
                  // this.currItems[newidx].know = this.currItems[newidx].know
                  //   ? this.currItems[newidx].know + 1
                  //   : 1;
                  console.log("RIGHT!", _this3.WIN);
                } else {
                  _this3.status = "wrong";
                  _this3.WIN = 0;
                  _this3.mistakes.push({ word: _this3.question.qWord, mistake: answer.heb });
                  console.log(_this3.mistakes);
                  // if (this.LOST != 2) {
                  _this3.LOST = _this3.LOST + 1;
                  // }
                  _this3.playAudio(0);
                  //this.playedItems[this.idx].isRight = false;
                  // const newidx = this.currItems.findIndex(
                  //   element => element.objectID === this.question.qWord.objectID
                  // );
                  // this.currItems[newidx].know = this.currItems[newidx].know
                  //   ? this.currItems[newidx].know - 1
                  //   : 0;
                  // this.currItems[newidx].wrong = this.currItems[newidx].wrong
                  //   ? this.currItems[newidx].wrong + 1
                  //   : 1;
                  console.log("WRONG!", _this3.WIN);
                }
                // const items = this.currItems.filter(
                //   item => item.know < this.WIN || !item.know
                // );

                if (!(_this3.WIN < 8)) {
                  _context3.next = 10;
                  break;
                }

                _this3.showNext = true;
                _context3.next = 32;
                break;

              case 10:
                // confetti({
                //   particleCount: 50,
                //   spread: 70,
                //   origin: { y: 0.6 },
                //   ticks: 200
                // });
                _this3.submitting = true;

                if (!_this3.data) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 14;
                return __WEBPACK_IMPORTED_MODULE_12__services_userService__["a" /* userService */].finishLesson(_this3.data.id, _this3.user);

              case 14:
                _context3.next = 16;
                return __WEBPACK_IMPORTED_MODULE_12__services_userService__["a" /* userService */].finishGame(_this3.data.game.id);

              case 16:
                if (!_this3.user) {
                  _context3.next = 27;
                  break;
                }

                if (!_this3.data) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 20;
                return __WEBPACK_IMPORTED_MODULE_12__services_userService__["a" /* userService */].updateRules([{ external_id: _this3.data.game.algolia_game_id, score: 4 }]);

              case 20:
                _this3.updateUser = _context3.sent;
                _context3.next = 27;
                break;

              case 23:
                if (!_this3.externalData) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 26;
                return __WEBPACK_IMPORTED_MODULE_12__services_userService__["a" /* userService */].updateRules([{ external_id: _this3.$route.params.gameid, score: 4 }]);

              case 26:
                _this3.updateUser = _context3.sent;

              case 27:
                if (!(_this3.externalData && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.externalData).length && _this3.user)) {
                  _context3.next = 30;
                  break;
                }

                _context3.next = 30;
                return __WEBPACK_IMPORTED_MODULE_12__services_userService__["a" /* userService */].finishGame(_this3.externalData.id);

              case 30:
                _this3.submitting = false;
                _this3.showResults = true;
                // this.playAudio(10);

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    nextQuestion: function nextQuestion() {
      this.choosenId = null;
      this.isClicked = false;
      this.idx++;
      this.showNext = false;
      this.playAudio();
      this.generateQuestion(this.question.qWord);
    },
    randomList: function randomList(answers) {
      return answers.sort(function () {
        return 0.5 - Math.random();
      });
    },
    showSummary: function showSummary() {
      var _$route$params4 = this.$route.params,
          id = _$route$params4.id,
          type = _$route$params4.type,
          grammar = _$route$params4.grammar;

      var progress = 0;
      var items = this.playedItems;
      items.forEach(function (item) {
        if (item.isRight) {
          progress += 1;
        }
      });
      progress = progress / this.playedItems.length * 100;
      var rightItems = this.playedItems.filter(function (i) {
        return i.isRight;
      });
      this.isSummary = true, this.showResults = false;
      this.msg = this.$t("grammarGame.game-page.welldone");
      if (!this.user) return;
    },
    restartGame: function restartGame() {
      this.mistakes = [];
      this.init();
    }
  },
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_8__Shared_progressBar_vue___default.a,
    AudioBtn: __WEBPACK_IMPORTED_MODULE_10__Shared_audioBtn_vue___default.a,
    GameSummary: __WEBPACK_IMPORTED_MODULE_6__game_summary_vue___default.a,
    GameHeader: __WEBPACK_IMPORTED_MODULE_7__game_header_vue___default.a,
    OnBoardingModal: __WEBPACK_IMPORTED_MODULE_9__onBoardingModal_OnBoardingModal_vue___default.a
  }
});

/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("d19bf0d4", content, true, {});

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".grammar-page{height:100vh;display:flex;flex-direction:column;justify-content:space-between}.grammar-page .game-header .title{text-align:center;color:var(--game-button-stroke);background-color:var(--bubble-primary);border:1px solid var(--game-button-stroke);font-weight:700}.grammar-page .game-main{margin-top:24px;font:var(--huge-font);display:flex;flex-direction:column;height:70vh;justify-content:end}.grammar-page .game-main .question{display:flex;flex-direction:column;align-items:center;justify-content:space-around;height:20vh}.grammar-page .game-main .question .q{font:var(--huge-font);text-align:center}.grammar-page .game-main .answers{-webkit-user-select:none;-ms-user-select:none;user-select:none;align-content:end;display:flex;flex-direction:column;margin:0 auto;margin-top:auto;grid-template-columns:repeat(1, 1fr);gap:8px;width:70%;padding:0}.grammar-page .game-main .answers li{transition:box-shadow .2s ease-in-out;border:2px solid var(--game-button-stroke);padding:8px;border-radius:80px;text-align:center;cursor:pointer}@media(min-width: 37.5em){.grammar-page .game-main .answers li:hover{color:var(--button-primary-text);background-color:var(--button-primary)}}.grammar-page .game-main .answers li:active{transform:scale(0.98);box-shadow:0px 0px var(--button-primary)}.grammar-page .actions-wrapper{padding:0;height:100px;margin-top:10vh;width:100%}.grammar-page .btn-next,.grammar-page .btn-restart,.grammar-page .btn-results,.grammar-page .btnSum{width:100%;height:100%;text-align:center;justify-content:center;border-radius:unset;font:var(--huge-font);display:flex;padding:8px;color:var(--button-primary-text);background-color:var(--button-primary)}.grammar-page .btn-next:hover,.grammar-page .btn-restart:hover,.grammar-page .btn-results:hover,.grammar-page .btnSum:hover{color:var(--button-primary-text);background-color:var(--bubble-bg-selected)}@-webkit-keyframes text-focus-in{0%{-webkit-filter:blur(12px);filter:blur(12px);opacity:0}100%{-webkit-filter:blur(0px);filter:blur(0px);opacity:1}}@keyframes text-focus-in{0%{-webkit-filter:blur(12px);filter:blur(12px);opacity:0}100%{-webkit-filter:blur(0px);filter:blur(0px);opacity:1}}.grammar-page .wrong{background-color:var(--error-primary);border-color:var(--error-primary) !important;color:var(--bg-primary)}.grammar-page .nope{transition:background-color 2s ease-in;transition:border-color 2s ease-in;background-color:var(--bg-primary);box-shadow:none !important;border-color:var(--bubble-primary) !important;color:var(--color-disabled) !important}.grammar-page .wrong{background-color:var(--error-primary);border-color:var(--error-primary) !important;color:var(--bg-primary) !important}.grammar-page .damnright{transition:background-color 2s ease-in;transition:border-color 2s ease-in;box-shadow:none !important;border-color:var(--success-secondary) !important;background-color:var(--success-primary);color:var(--success-secondary) !important}.grammar-page .damnright:hover{color:var(--bg-primary) !important;background-color:var(--bubble-bg-selected)}.grammar-page .tracking-in-expand{-webkit-animation:text-focus-in .5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;animation:text-focus-in .5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/src/components/GrammarGame/game-page.scss","/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,cACE,aACA,aACA,sBACA,6BAAA,CAGE,kCACE,kBACA,gCACA,uCACA,2CACA,eAAA,CAIJ,yBACE,gBACA,sBACA,aACA,sBACA,YACA,mBAAA,CAEA,mCACE,aACA,sBACA,mBACA,6BACA,WAAA,CAEA,sCACE,sBACA,iBAAA,CAIJ,kCACE,yBACA,qBACA,iBACA,kBACA,aACA,sBACA,cACA,gBACA,qCACA,QACA,UACA,SAAA,CAEA,qCACE,sCACA,2CACA,YACA,mBACA,kBAEA,cAAA,CChDJ,0BDkDI,2CAEI,iCACA,sCAAA,CAAA,CAIJ,4CACE,sBACA,wCAAA,CAMR,+BACE,UACA,aACA,gBACA,UAAA,CAGF,oGAIE,WACA,YACA,kBACA,uBACA,oBACA,sBACA,aACA,YACA,iCACA,sCAAA,CAEA,4HACE,iCACA,0CAAA,CAgBJ,iCACE,GACE,0BACA,kBACA,SAAA,CAGF,KACE,yBACA,iBACA,SAAA,CAAA,CAIJ,yBACE,GACE,0BACA,kBACA,SAAA,CAGF,KACE,yBACA,iBACA,SAAA,CAAA,CAIJ,qBACE,sCACA,6CACA,uBAAA,CAGF,oBACE,uCACA,mCACA,mCACA,2BACA,8CACA,sCAAA,CAIF,qBACE,sCACA,6CACA,kCAAA,CAGF,yBACE,uCACA,mCACA,2BAEA,iDACA,wCACA,yCAAA,CAEA,+BACE,mCACA,0CAAA,CAKJ,kCACE,+EAEA,sEAAA,CAAA","file":"game-page.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.grammar-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .game-header {\n    .title {\n      text-align: center;\n      color: var(--game-button-stroke);\n      background-color: var(--bubble-primary);\n      border: 1px solid var(--game-button-stroke);\n      font-weight: 700;\n    }\n  }\n\n  .game-main {\n    margin-top: 24px;\n    font: var(--huge-font);\n    display: flex;\n    flex-direction: column;\n    height: 70vh;\n    justify-content: end;\n\n    .question {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-around;\n      height: 20vh;\n\n      .q {\n        font: var(--huge-font);\n        text-align: center;\n      }\n    }\n\n    .answers {\n      -webkit-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      align-content: end;\n      display: flex;\n      flex-direction: column;\n      margin: 0 auto;\n      margin-top: auto;\n      grid-template-columns: repeat(1, 1fr);\n      gap: 8px;\n      width: 70%;\n      padding: 0;\n\n      li {\n        transition: box-shadow 0.2s ease-in-out;\n        border: 2px solid var(--game-button-stroke);\n        padding: 8px;\n        border-radius: 80px;\n        text-align: center;\n\n        cursor: pointer;\n\n        &:hover {\n          @include respon(no-phone) {\n            color: var(--button-primary-text);\n            background-color: var(--button-primary);\n          }\n        }\n\n        &:active {\n          transform: scale(0.98);\n          box-shadow: 0px 0px var(--button-primary);\n        }\n      }\n    }\n  }\n\n  .actions-wrapper {\n    padding: 0;\n    height: 100px;\n    margin-top: 10vh;\n    width: 100%;\n  }\n\n  .btn-next,\n  .btn-restart,\n  .btn-results,\n  .btnSum {\n    width: 100%;\n    height: 100%;\n    text-align: center;\n    justify-content: center;\n    border-radius: unset;\n    font: var(--huge-font);\n    display: flex;\n    padding: 8px;\n    color: var(--button-primary-text);\n    background-color: var(--button-primary);\n\n    &:hover {\n      color: var(--button-primary-text);\n      background-color: var(--bubble-bg-selected);\n    }\n  }\n\n  /* ----------------------------------------------\n  * Generated by Animista on 2023-2-10 11:35:37\n  * Licensed under FreeBSD License.\n  * See http://animista.net/license for more info. \n  * w: http://animista.net, t: @cssanimista\n  * ---------------------------------------------- */\n\n  /**\n  * ----------------------------------------\n  * animation text-focus-in\n  * ----------------------------------------\n  */\n  @-webkit-keyframes text-focus-in {\n    0% {\n      -webkit-filter: blur(12px);\n      filter: blur(12px);\n      opacity: 0;\n    }\n\n    100% {\n      -webkit-filter: blur(0px);\n      filter: blur(0px);\n      opacity: 1;\n    }\n  }\n\n  @keyframes text-focus-in {\n    0% {\n      -webkit-filter: blur(12px);\n      filter: blur(12px);\n      opacity: 0;\n    }\n\n    100% {\n      -webkit-filter: blur(0px);\n      filter: blur(0px);\n      opacity: 1;\n    }\n  }\n\n  .wrong {\n    background-color: var(--error-primary);\n    border-color: var(--error-primary) !important;\n    color: var(--bg-primary);\n  }\n\n  .nope {\n    transition: background-color 2s ease-in;\n    transition: border-color 2s ease-in;\n    background-color: var(--bg-primary);\n    box-shadow: none !important;\n    border-color: var(--bubble-primary) !important;\n    color: var(--color-disabled) !important;\n    // border-color: gray !important;\n  }\n\n  .wrong {\n    background-color: var(--error-primary);\n    border-color: var(--error-primary) !important;\n    color: var(--bg-primary) !important;\n  }\n\n  .damnright {\n    transition: background-color 2s ease-in;\n    transition: border-color 2s ease-in;\n    box-shadow: none !important;\n    // border-width: 0px !important;\n    border-color: var(--success-secondary) !important;\n    background-color: var(--success-primary);\n    color: var(--success-secondary) !important;\n\n    &:hover {\n      color: var(--bg-primary) !important;\n      background-color: var(--bubble-bg-selected);\n    }\n  }\n\n\n  .tracking-in-expand {\n    -webkit-animation: text-focus-in 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53)\n      both;\n    animation: text-focus-in 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;\n  }\n}\n\n","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(418),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0ae1a49d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(414);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("89470848", content, true, {});

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\nbutton[data-v-0ae1a49d] {\n  border: none;\n}\n.progress-icon[data-v-0ae1a49d] {\n  height: 24px;\n}\n.translations[data-v-0ae1a49d] {\n  font: var(--medium-font);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 55%;\n  text-align: center;\n}\n.gmistakes-header[data-v-0ae1a49d] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 74px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0 10px;\n}\n.gmistakes[data-v-0ae1a49d] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0 10px;\n}\n.idx[data-v-0ae1a49d] {\n  margin: 0 12px;\n  width: 0.5em;\n}\n.audio[data-v-0ae1a49d] {\n  margin-right: 6px;\n  /* width: 2em; */\n}\n.played-words[data-v-0ae1a49d] {\n  margin-top: 20px;\n  font: var(--medium-font);\n  width: 100%;\n  margin-bottom: 10px;\n}\n.saveWord[data-v-0ae1a49d] {\n  fill: var(--button-primary-text);\n}\n.blackBG-grammar[data-v-0ae1a49d] {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.modal[data-v-0ae1a49d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  z-index: 11;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 12px;\n  border-radius: 4px;\n  max-width: 80vw;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  position: absolute;\n  top: 50%;\n}\n.backBtn[data-v-0ae1a49d] {\n  margin-bottom: 20px;\n}\n.wbold[data-v-0ae1a49d] {\n  font-weight: 700;\n  text-decoration: underline;\n}\n.g-q[data-v-0ae1a49d] {\n  color: var(--game-button-primary);\n  width: 30%;\n}\n.g-a[data-v-0ae1a49d] {\n  color: var(--button-primary);\n  width: 30%;\n}\n.g-m[data-v-0ae1a49d] {\n  color: var(--error-primary);\n  width: 30%;\n}\n.g-head[data-v-0ae1a49d] {\n  width: 40%;\n}\n.btnSummry[data-v-0ae1a49d] {\n  border-radius: 6px;\n  width: 100%;\n  font: var(--medium-font);\n}\n.btnRestart[data-v-0ae1a49d] {\n  color: var(--game-button-primary);\n  background-color: var(--bubble-primary);\n}\n.btnGo[data-v-0ae1a49d] {\n  color: var(--button-primary);\n  background-color: var(--button-primary);\n  margin-top: 8px;\n  height: 60px;\n}\n.btnRes[data-v-0ae1a49d] {\n  color: var(--color-primary);\n  background-color: var(--button-restart-primary);\n}\n.btnsDiv[data-v-0ae1a49d] {\n  gap: 5px;\n  width: 100%;\n  height: 50px;\n}\n.divMistakes[data-v-0ae1a49d] {\n  font: var(--medium-font);\n}\n.description[data-v-0ae1a49d] {\n  font: var(--huge-font);\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/game-summary.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,WAAW;EACX,mBAAmB;CACpB;AACD;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,eAAe;CAChB;AACD;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,0BAA0B;MACtB,uBAAuB;UACnB,+BAA+B;EACvC,eAAe;CAChB;AACD;EACE,eAAe;EACf,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;MAC1B,2BAA2B;UACvB,uBAAuB;EAC/B,0BAA0B;MACtB,uBAAuB;UACnB,oBAAoB;EAC5B,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;UACjC,iCAAiC;EACzC,mBAAmB;EACnB,SAAS;CACV;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,2BAA2B;CAC5B;AACD;EACE,kCAAkC;EAClC,WAAW;CACZ;AACD;EACE,6BAA6B;EAC7B,WAAW;CACZ;AACD;EACE,4BAA4B;EAC5B,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;CAC1B;AACD;EACE,kCAAkC;EAClC,wCAAwC;CACzC;AACD;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;CACd;AACD;EACE,4BAA4B;EAC5B,gDAAgD;CACjD;AACD;EACE,SAAS;EACT,YAAY;EACZ,aAAa;CACd;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,uBAAuB;CACxB","file":"game-summary.vue","sourcesContent":["\nbutton[data-v-0ae1a49d] {\n  border: none;\n}\n.progress-icon[data-v-0ae1a49d] {\n  height: 24px;\n}\n.translations[data-v-0ae1a49d] {\n  font: var(--medium-font);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 55%;\n  text-align: center;\n}\n.gmistakes-header[data-v-0ae1a49d] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 74px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0 10px;\n}\n.gmistakes[data-v-0ae1a49d] {\n  border-bottom: 1px solid var(--color-primary);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin: 0 10px;\n}\n.idx[data-v-0ae1a49d] {\n  margin: 0 12px;\n  width: 0.5em;\n}\n.audio[data-v-0ae1a49d] {\n  margin-right: 6px;\n  /* width: 2em; */\n}\n.played-words[data-v-0ae1a49d] {\n  margin-top: 20px;\n  font: var(--medium-font);\n  width: 100%;\n  margin-bottom: 10px;\n}\n.saveWord[data-v-0ae1a49d] {\n  fill: var(--button-primary-text);\n}\n.blackBG-grammar[data-v-0ae1a49d] {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n.modal[data-v-0ae1a49d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  text-align: center;\n  z-index: 11;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 12px;\n  border-radius: 4px;\n  max-width: 80vw;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  position: absolute;\n  top: 50%;\n}\n.backBtn[data-v-0ae1a49d] {\n  margin-bottom: 20px;\n}\n.wbold[data-v-0ae1a49d] {\n  font-weight: 700;\n  text-decoration: underline;\n}\n.g-q[data-v-0ae1a49d] {\n  color: var(--game-button-primary);\n  width: 30%;\n}\n.g-a[data-v-0ae1a49d] {\n  color: var(--button-primary);\n  width: 30%;\n}\n.g-m[data-v-0ae1a49d] {\n  color: var(--error-primary);\n  width: 30%;\n}\n.g-head[data-v-0ae1a49d] {\n  width: 40%;\n}\n.btnSummry[data-v-0ae1a49d] {\n  border-radius: 6px;\n  width: 100%;\n  font: var(--medium-font);\n}\n.btnRestart[data-v-0ae1a49d] {\n  color: var(--game-button-primary);\n  background-color: var(--bubble-primary);\n}\n.btnGo[data-v-0ae1a49d] {\n  color: var(--button-primary);\n  background-color: var(--button-primary);\n  margin-top: 8px;\n  height: 60px;\n}\n.btnRes[data-v-0ae1a49d] {\n  color: var(--color-primary);\n  background-color: var(--button-restart-primary);\n}\n.btnsDiv[data-v-0ae1a49d] {\n  gap: 5px;\n  width: 100%;\n  height: 50px;\n}\n.divMistakes[data-v-0ae1a49d] {\n  font: var(--medium-font);\n}\n.description[data-v-0ae1a49d] {\n  font: var(--huge-font);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_summary_scss__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_summary_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__game_summary_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AudioPlayer_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_courseService__ = __webpack_require__(77);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "game-summary",
  props: {
    playedItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    msg: {
      type: String,
      //   default: this.$t("grammarGame.game-summery.next")
      default: "עברו על המילים כדי להצליח בפעם הבאה"
    },
    mistakes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currentData: {
      type: Object,
      default: function _default() {}
    },
    externalData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      audioSrc: null,
      vidSrc: null,
      imgSrc: null,
      outText: null,
      results: false,
      isAutoPlay: true,
      exData: null,
      allTranslationsHeight: [],
      ltr: localStorage.getItem("srcDirection") == "ltr"
    };
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    currentData: function currentData() {
      if (this.currentData.game.outro_image) this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio) this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video) this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text) this.outText = this.currentData.game.outro_text;
    },
    exData: function exData() {
      if (this.exData.outro_image) this.imgSrc = this.exData.outro_image;
      if (this.exData.outro_audio) this.audioSrc = this.exData.outro_audio;
      if (this.exData.outro_video) this.vidSrc = this.exData.outro_video;
      if (this.exData.outro_text) this.outText = this.exData.outro_text;
    },
    results: function results() {
      this.isAutoPlay = false;
    }
  },
  methods: {
    restartGame: function restartGame() {
      this.$emit("restartGame");
    },
    goBack: function goBack() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // let thisLessonId = this.$store.getters.nextLesson.id
                // if (thisLessonId) {
                //   await userService.finishLesson(thisLessonId, this.user);
                // }

                _this.$router.push("/chapter/");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    goNext: function goNext() {
      this.$router.push("/lesson/" + this.$store.getters.nextLesson.id);
      // this.results = false;
    },

    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.externalData) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_8__services_courseService__["a" /* courseService */].getGame(_this2.externalData.id);

            case 3:
              _this2.exData = _context2.sent;

            case 4:
              if (_this2.currentData) {
                if (_this2.currentData.game.outro_image) _this2.imgSrc = _this2.currentData.game.outro_image;
                if (_this2.currentData.game.outro_audio) _this2.audioSrc = _this2.currentData.game.outro_audio;
                if (_this2.currentData.game.outro_video) _this2.vidSrc = _this2.currentData.game.outro_video;
                if (_this2.currentData.game.outro_text) _this2.outText = _this2.currentData.game.outro_text;
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },

  components: {
    AudioBtn: __WEBPACK_IMPORTED_MODULE_3__Shared_audioBtn_vue___default.a,
    AudioPlayer: __WEBPACK_IMPORTED_MODULE_4__Shared_AudioPlayer_vue___default.a,
    VideoPlayer: __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue___default.a,
    VideoPlayer1: __WEBPACK_IMPORTED_MODULE_5__Shared_VideoPlayer_vue___default.a,
    Spacer: __WEBPACK_IMPORTED_MODULE_7__Shared_Spacer_vue___default.a
  }
});

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(417);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("3cb29eec", content, true, {});

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".game-summary{min-height:400px;width:300px;margin:0 auto}.game-summary p{text-align:center}.game-summary .line{align-items:center;margin-bottom:10px}.game-summary .line .idx{flex:1}.game-summary .line .translations{flex:2}.game-summary .line .translations .word{overflow:hidden;text-overflow:ellipsis;width:140px;white-space:nowrap}.game-summary .title{text-align:center}.mistakes{position:absolute;z-index:-1}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/src/components/GrammarGame/game-summary.scss"],"names":[],"mappings":"AACA,cACE,iBACA,YAqBA,aAAA,CApBA,gBACE,iBAAA,CAEF,oBACE,mBACA,kBAAA,CACA,yBACE,MAAA,CAGF,kCACE,MAAA,CACA,wCACE,gBACA,uBACA,YACA,kBAAA,CAKN,qBACE,iBAAA,CAIJ,UACE,kBACA,UAAA,CAAA","file":"game-summary.scss","sourcesContent":["@import \"../../scss/abstracts/mixins\";\n.game-summary {\n  min-height: 400px;\n  width: 300px;\n  p {\n    text-align: center;\n  }\n  .line {\n    align-items: center;\n    margin-bottom: 10px;\n    .idx {\n      flex: 1;\n    }\n\n    .translations {\n      flex: 2;\n      .word {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        width: 140px;\n        white-space: nowrap;\n      }\n    }\n  }\n  margin: 0 auto;\n  .title {\n    text-align: center;\n  }\n}\n\n.mistakes {\n  position: absolute;\n  z-index: -1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "blackBG-grammar"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [(_vm.results) ? _c('div', {
    staticClass: "played-words"
  }, [(_vm.results) ? _c('div', {
    staticClass: "backBtn",
    on: {
      "click": function($event) {
        _vm.results = false
      }
    }
  }, [_c('inline-svg', {
    staticClass: "cup-svg saveWord",
    attrs: {
      "src": __webpack_require__(224).default
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t("grammarGame.game-summery.improve")))]), _vm._v(" "), (_vm.mistakes.length) ? _c('div', [_c('div', {
    staticClass: "gmistakes-header"
  }, [_c('div', {
    staticClass: "wbold g-head"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("grammarGame.game-summery.question")) + "\n          ")]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "wbold"
  }, [_vm._v(_vm._s(_vm.$t("grammarGame.game-summery.answer")))]), _vm._v(" "), _c('div', {
    staticClass: "wbold"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("grammarGame.game-summery.mistake")) + "\n          ")])]), _vm._v(" "), _vm._l((_vm.mistakes), function(word, idx) {
    return _c('div', {
      key: idx,
      staticClass: "gmistakes"
    }, [_c('div', {
      staticClass: "audio"
    }, [_c('AudioBtn', {
      attrs: {
        "urlId": word.word.id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "g-q"
    }, [_vm._v(_vm._s(word.word.eng))]), _vm._v(" "), _c('div', {
      staticClass: "g-a arial"
    }, [_vm._v(_vm._s(word.word.heb))]), _vm._v(" "), _c('div', {
      staticClass: "g-m"
    }, [_vm._v(_vm._s(word.mistake))])])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.mistakes.length) ? _c('div', {
    staticClass: "divMistakes",
    style: ({
      textAlign: _vm.ltr ? 'left' : 'right'
    })
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.perfect")) + "\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.outText))]), _vm._v(" "), (_vm.audioSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": _vm.isAutoPlay
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('Spacer', {
    attrs: {
      "height": "12"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.imgSrc
    }
  }) : _vm._e(), _vm._v(" "), _c('Spacer', {
    attrs: {
      "height": "12"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('div', {
    staticClass: "flex btnsDiv"
  }, [_c('button', {
    staticClass: "btnSummry btnRestart",
    on: {
      "click": _vm.restartGame
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.again")) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btnSummry btnRes",
    on: {
      "click": function($event) {
        _vm.results = true
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-summery.results")) + "\n      ")])]) : _vm._e(), _vm._v(" "), (!_vm.results) ? _c('button', {
    staticClass: "btnSummry btnGo",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("grammarGame.game-summery.continue")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(425),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-155a5166",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("bac46afe", content, true, {});

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.backarrowDiv[data-v-155a5166] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-155a5166] {\n  margin: auto;\n  height: 30px;\n  fill: var(--button-primary-text);\n  aspect-ratio: 1/1;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/game-header.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;EACb,aAAa;EACb,iCAAiC;EACjC,kBAAkB;CACnB","file":"game-header.vue","sourcesContent":["\n.backarrowDiv[data-v-155a5166] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-game[data-v-155a5166] {\n  margin: auto;\n  height: 30px;\n  fill: var(--button-primary-text);\n  aspect-ratio: 1/1;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game_header_scss__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__game_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__game_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_svgConfig__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(78);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "GameHeader",
  props: ["currentData", "word", "WIN", "status", "externalData"],
  data: function data() {
    return {
      lessonName: this.$t("grammarGame.game-header.title"),
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },

  computed: {
    // wordRank() {
    //   return this.word.qWord.know || 0;
    // }
  },
  watch: {
    currentData: function currentData() {
      console.log("I AM HERE");
      this.lessonName = this.currentData.lesson.name;
    }
  },
  created: function created() {
    this.arrowIconPath = Object(__WEBPACK_IMPORTED_MODULE_2__utils_svgConfig__["a" /* getArrowIconPath */])(localStorage.getItem("srcDirection"));
    console.log(this.externalData);
  },

  methods: {
    prevChapter: function prevChapter(event) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.externalData).length) {
        this.$router.push({
          path: "/external-grammar/"
        });
      } else {
        this.$router.push({
          path: "/chapter/"
        });
      }
    }
  },
  components: {}
});

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("342aaa9a", content, true, {});

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".game-header{display:grid;justify-content:space-between;background-color:var(--header-primary);height:60px;grid-template-columns:15% 1fr 15%;align-items:center;justify-items:center}.game-header h2{text-align:center;font:var(--huge-font)}.game-header h6{font:var(--medium-font);color:var(--button-primary-text)}.game-titles{display:flex;flex-direction:column;align-items:center;justify-content:space-between}.finjan-svg{width:35px;height:35px;margin:6px 12px 0px 12px;fill:#fefb01;stroke:#000}.finjan-svg-1{fill:#cefb02}.finjan-svg-3{fill:#87fa00}.finjan-svg-5{fill:#3af901}.finjan-svg-7{fill:#00ed01}.finjan-svg-8{fill:#3f0}.finjan-svg-wrong{fill:red}.cup-svg{width:35px;height:35px}.arrow-svg-chap{width:12px}.disabled{fill:var(--color-disabled)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/GrammarGame/src/components/GrammarGame/game-header.scss"],"names":[],"mappings":"AAEA,aACE,aACA,8BACA,uCACA,YACA,kCACA,mBACA,oBAAA,CAEA,gBACE,kBACA,qBAAA,CAEF,gBACE,wBACA,gCAAA,CAIJ,aACE,aACA,sBACA,mBACA,6BAAA,CAGF,YACE,WACA,YACA,yBACA,aACA,WAAA,CAEF,cACE,YAAA,CAEF,cACE,YAAA,CAEF,cACE,YAAA,CAEF,cACE,YAAA,CAEF,cACE,SAAA,CAGF,kBACE,QAAA,CAEF,SACE,WACA,WAAA,CAEF,gBACE,UAAA,CAGF,UACE,0BAAA,CAAA","file":"game-header.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.game-header {\n  display: grid;\n  justify-content: space-between;\n  background-color: var(--header-primary);\n  height: 60px;\n  grid-template-columns: 15% 1fr 15%;\n  align-items: center;\n  justify-items: center;\n\n  h2 {\n    text-align: center;\n    font: var(--huge-font);\n  }\n  h6 {\n    font: var(--medium-font);\n    color: var(--button-primary-text);\n  }\n}\n\n.game-titles {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.finjan-svg {\n  width: 35px;\n  height: 35px;\n  margin: 6px 12px 0px 12px;\n  fill: #fefb01;\n  stroke: black;\n}\n.finjan-svg-1 {\n  fill: #cefb02;\n}\n.finjan-svg-3 {\n  fill: #87fa00;\n}\n.finjan-svg-5 {\n  fill: #3af901;\n}\n.finjan-svg-7 {\n  fill: #00ed01;\n}\n.finjan-svg-8 {\n  fill: #33ff00;\n}\n\n.finjan-svg-wrong {\n  fill: red;\n}\n.cup-svg {\n  width: 35px;\n  height: 35px;\n}\n.arrow-svg-chap {\n  width: 12px;\n}\n\n.disabled {\n  fill: var(--color-disabled);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 425:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-game",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "game-titles"
  }, [_c('h6', [_vm._v("\n      " + _vm._s(_vm.currentData && _vm.currentData.courseName) + "\n      " + _vm._s(_vm.externalData ? _vm.externalData.name : _vm.$t("grammarGame.game-header.title")) + "\n    ")]), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.currentData ? _vm.currentData.name : _vm.$t("grammarGame.game-header.title")) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.chapter) ? _c('div', [_vm._v(_vm._s(_vm.$t("grammarGame.game-page.loading")))]) : _vm._e(), _vm._v(" "), (_vm.chapter) ? _c('div', {
    staticClass: "grammar-page"
  }, [_c('GameHeader', {
    attrs: {
      "currentData": _vm.data,
      "externalData": _vm.externalData,
      "word": _vm.currentWord,
      "WIN": _vm.WIN,
      "status": _vm.status
    }
  }), _vm._v(" "), (_vm.isSummary) ? _c('GameSummary', {
    attrs: {
      "msg": _vm.msg,
      "playedItems": _vm.currItems,
      "mistakes": _vm.mistakes,
      "currentData": _vm.data,
      "externalData": _vm.externalData
    },
    on: {
      "restartGame": _vm.restartGame
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isSummary) ? _c('div', {
    staticClass: "game-main"
  }, [(_vm.question) ? _c('div', {
    staticClass: "question"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [(!_vm.question.onlyAudio) ? _c('span', {
    key: _vm.question.qWord.eng,
    staticClass: "q"
  }, [_vm._v("\n            " + _vm._s(_vm.question.qWord.eng))]) : _vm._e()]), _vm._v(" "), (_vm.question.qWord.id) ? _c('AudioBtn', {
    attrs: {
      "urlId": _vm.question.qWord.id,
      "autoplay": _vm.autoPlay,
      "idx": _vm.idx
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.question) ? _c('ul', {
    staticClass: "answers grid"
  }, _vm._l((_vm.question.answers), function(answer) {
    return _c('li', {
      key: answer.objectID,
      class: {
        right: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        wrong: _vm.choosenId === answer.objectID &&
          _vm.question.qWord.objectID !== answer.objectID,
        nope: _vm.choosenId && _vm.question.qWord.objectID !== answer.objectID,
        rightword: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID,
        damnright: _vm.choosenId && _vm.question.qWord.objectID === answer.objectID
      },
      on: {
        "click": function($event) {
          return _vm.checkAnswerA(answer, _vm.idx)
        }
      }
    }, [_vm._v("\n          " + _vm._s(answer.heb) + "\n        ")])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [(_vm.showNext) ? _c('button', {
    staticClass: "btn-next",
    on: {
      "click": _vm.nextQuestion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-page.next_q")) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.submitting) ? _c('button', {
    staticClass: "btnSum"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showResults) ? _c('button', {
    staticClass: "btnSum",
    on: {
      "click": _vm.showSummary
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("grammarGame.game-page.summery")) + "\n      ")]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 3.ce03fd3d81a126f24b18.bundle.js